<template>
  <div>
    <!-- 工具栏 -->
    <div style="display: flex; justify-content: space-between">
      <!-- 搜索 -->
      <div>
        <el-input
          style="width: 180px; margin-right: 10px"
          prefix-icon="el-icon-edit"
          v-model="searchValue.needName"
          size="small"
          placeholder="请输入需求名称"
          clearable
        >
        </el-input>

        <el-input
          style="width: 150px; margin-right: 10px"
          prefix-icon="el-icon-edit"
          v-model="searchValue.needCode"
          size="mini"
          placeholder="请输入需求编号"
          clearable
        >
        </el-input>
        <el-date-picker
          v-model="searchValue.rqScope"
          size="mini"
          type="daterange"
          value-format="yyyy-MM-dd"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          clearable
        >
        </el-date-picker>

        <span style="margin-right: 10px"></span>
        <el-select
          v-model="searchValue.needStage"
          size="mini"
          style="width: 130px"
          placeholder="需求阶段"
          clearable
        >
          <el-option
            v-for="item in needStages"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>

        <span style="margin-right: 10px"></span>
        <el-select
          v-model="searchValue.createUserId"
          size="mini"
          style="width: 120px"
          placeholder="需求发起人"
          v-if="!qx"
          clearable
        >
          <el-option
            v-for="item in createUserIds"
            :key="item.id"
            :label="item.uname"
            :value="item.id"
          >
          </el-option>
        </el-select>

        <el-button
          type="primary"
          icon="el-icon-search"
          @click="onSearch"
          size="small"
          style="margin-left: 20px"
          >搜索</el-button
        >
        <!-- <el-button type="primary" disabled="true" size="small"> <i class="fa fa-angle-double-down" aria-hidden="true"></i>
					高级搜索</el-button> -->
      </div>
      <!-- 右边工具
			  <el-button type="primary" icon="el-icon-plus" @click="showAddView" size="small" v-if="qx">添加需求</el-button>
			 -->
      <div>
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="showAddView"
          size="small"
          v-if="qx1"
          >添加需求</el-button
        >
      </div>
    </div>
    <!-- 表格 -->
    <div style="margin-top: 20px">
      <el-table
        :data="needData"
        stripe
        border
        :row-style="{ height: '59px' }"
        height="calc(100vh - 280px)"
        :cell-style="{ padding: '5px 0' }"
        size="small"
        fit
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        @row-dblclick="advanceRecordView"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="width: 100%"
      >
        <!-- 多选框 -->
        <!-- <el-table-column type="selection" align="center" width="55"></el-table-column> -->
        <!-- <el-table-column prop="id" label="主键ID"  fixed align="center" width="90">
				</el-table-column> -->
        <el-table-column
          prop="needCode"
          label="需求编号"
          fixed
          align="center"
          width="130"
        >
        </el-table-column>
        <el-table-column
          prop="needName"
          label="需求名称"
          align="center"
          width="220"
        >
        </el-table-column>
        <!-- 需求内容名称-->
        <!-- <el-table-column prop="needContent" label="需求内容"  align="center">
				</el-table-column> -->

        <el-table-column label="需求内容" align="center">
          <template slot-scope="scope">
            <!--  实现拉宽后，不断增加字显示个数 -->
            <span class="diandian">{{ scope.row.needContent }}</span>
          </template>
        </el-table-column>

        <!-- 	<el-table-column prop="appendixUrl" label="附件url地址"  align="center">
				</el-table-column>
				<el-table-column prop="createUserId" label="需求创建人id"  align="center">
				</el-table-column> -->
        <el-table-column
          prop="createUserName"
          label="需求创建人"
          align="center"
          width="90"
        >
        </el-table-column>
        <!-- 				<el-table-column prop="needStage" label="需求阶段"  align="center">
				</el-table-column> -->
        <!-- 需求阶段名称-->
        <el-table-column
          prop="needStageName"
          label="需求阶段"
          align="center"
          width="130"
        >
        </el-table-column>
        <!-- <el-table-column prop="state" label="状态"  align="center">
				</el-table-column> -->
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center"
          width="140"
        
        :formatter="dateTimeTwoLine"
        class-name="cell-two-line"
        >
        </el-table-column>
        <!-- <el-table-column prop="updateTime" label="更新时间"  align="center" width="140">
				</el-table-column> -->

        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="100"
          v-if="qx"
        >
          <template slot-scope="scope">
            <!-- <el-button type="primary" size="mini" @click="showEditView(scope.row)" :disabled="kaiguan1(scope.row.needStage)">编辑</el-button>
						<el-button type="danger" @click="deleteRecord(scope.row)" size="mini" :disabled="kaiguan1(scope.row.needStage)">删除</el-button> -->
            <el-tooltip
              class="item"
              effect="light"
              content="编辑"
              placement="top"
              v-if="!kaiguan1(scope.row.needStage)"
            >
              <el-button
                style="float: none; padding: 3px 0; color: #ff0000"
                type="text"
                icon="el-icon-setting"
                @click="showEditView(scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="light"
              content="编辑"
              placement="top"
              v-if="!kaiguan1(scope.row.needStage)"
            >
              <el-button
                style="float: none; padding: 3px 0; color: #ff0000"
                type="text"
                icon="el-icon-setting"
                @click="showEditView(scope.row)"
              ></el-button>
            </el-tooltip>
            <el-link
              :href="scope.row.fileUrl"
              v-if="scope.row.fileUrl"
              target="_blank"
              style="font-size: 13px"
              size="mini"
              download
              type="primary"
              :underline="false"
              >查看附件</el-link
            >
            <el-tooltip
              class="item"
              effect="light"
              content="删除"
              placement="top"
              v-if="!kaiguan1(scope.row.needStage)"
            >
              <el-button
                style="float: none; padding: 3px 0; color: #ff0000"
                type="text"
                icon="el-icon-delete"
                @click="deleteRecord(scope.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div style="display: flex; justify-content: flex-end; margin-top: 5px">
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          layout="sizes, prev, pager, next, jumper, ->, total"
          :total="total"
          :current-page="page">
        </el-pagination>
      </div>
    </div>
    <!-- 弹出框  dialogVisible:是否弹出 添加或编辑-->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="70%"       :close-on-click-modal="false"
      :close-on-press-escape="false"
>
      <div>
        <!-- 增加一层 el-form表单，可以数据校验 -->
        <el-form ref="inputForm" :model="inputObj" :rules="rules">
          <el-row>
            <el-col :span="24">
              <el-form-item label="需求名称" prop="needName">
                <el-input
                  type="text"
                  size="mini"
                  prefix-icon="el-icon-edit"
                  style="width: 770px"
                  v-model="inputObj.needName"
                  placeholder="请输入需求名称"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="需求内容" prop="needContent">
                <el-input
                  type="textarea"
                  size="mini"
                  prefix-icon="el-icon-edit"
                  style="width: 770px"
                  :autosize="{ minRows: 8, maxRows: 8 }"
                  v-model="inputObj.needContent"
                  placeholder="请输入需求内容"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="附件上传">
                <el-upload
                  ref="upload"
                  :on-change="onChange"
                  :auto-upload="false"
                  action=""
                >
                  <el-button size="small" type="primary" icon="el-icon-upload2"
                    >点击上传</el-button
                  >
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doChance">取 消</el-button>
        <el-button type="primary" @click="doAddRecord">保 存</el-button>
        <el-button type="primary" @click="doAddRecord2">保存且提交</el-button>
      </span>
    </el-dialog>

    <!-- 弹出框  AdvanceDialogVisible:是否弹出  推进需求   -->
    <el-dialog
      title="需求管理"
      :visible.sync="AdvanceDialogVisible"
      width="80%"
      top="0px"
            :close-on-click-modal="false"
      :close-on-press-escape="false"

    >
      <!-- 需求进度  -->
      <el-card class="box-card">
        <div style="display: flex; justify-content: space-between">
          <div style="font-weight: bold">需求审批进度</div>
        </div>
        <hr
          style="
            background-color: #eaeaea;
            color: #eaeaea;
            height: 1px;
            border: 1px none #000000;
          "
        />
        <div v-if="jdNormal" style="margin-left: 30px; margin-right: 30px">
          <span>&nbsp;&nbsp;</span>
          <el-steps
            :active="dispObj.needStage"
            finish-status="success"
            align-left
          >
            <el-step title="SS1:保存未提交"></el-step>
            <el-step title="SS2:已提交，待研发确认"></el-step>
            <el-step title="SS3:已确认，待审批"></el-step>
            <el-step title="SS4:审批完成"></el-step>
          </el-steps>
        </div>

        <div v-if="jdYanfa" style="margin-left: 30px; margin-right: 30px">
          <span>&nbsp;&nbsp;</span>
          <el-steps active="3" finish-status="success" align-left>
            <el-step title="SS1:保存未提交"></el-step>
            <el-step title="SS2:已提交，待研发确认"></el-step>
            <el-step title="SS3:研发已驳回"></el-step>
          </el-steps>
        </div>

        <div v-if="jdNopass" style="margin-left: 30px; margin-right: 30px">
          <span>&nbsp;&nbsp;</span>
          <el-steps active="4" finish-status="success" align-left>
            <el-step title="SS1:保存未提交"></el-step>
            <el-step title="SS2:已提交，待研发确认"></el-step>
            <el-step title="SS3:已确认，待审批"></el-step>
            <el-step title="SS4:审批未通过"></el-step>
          </el-steps>
        </div>

        <div v-if="yfShowOpen" style="margin-top: 20px; margin-left: 30px">
          <el-form ref="adviseForm" :model="adviseObj" :rules="rules2">
            <el-row>
              <el-col :span="24">
                <el-form-item label="意见/建议" prop="advise">
                  <el-input
                    type="textarea"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 770px"
                    :autosize="{ minRows: 2, maxRows: 2 }"
                    v-model="adviseObj.advise"
                    placeholder="请输入意见/建议"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-button
            type="warning"
            style="margin-top: 12px; margin-left: 90px"
            @click="yfBack"
            >需求驳回</el-button
          >
          <el-button
            type="primary"
            style="margin-top: 12px; margin-left: 30px"
            @click="yfOk"
            >确认通过</el-button
          >
        </div>

        <div v-if="ywShowOpen" style="margin-top: 20px; margin-left: 30px">
          <el-form ref="adviseForm" :model="adviseObj" :rules="rules2">
            <el-row>
              <el-col :span="24">
                <el-form-item label="意见/建议" prop="advise">
                  <el-input
                    type="textarea"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 770px"
                    :autosize="{ minRows: 2, maxRows: 2 }"
                    v-model="adviseObj.advise"
                    placeholder="请输入意见/建议"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-button
            type="warning"
            style="margin-top: 12px; margin-left: 90px"
            @click="ywBack"
            >审批驳回</el-button
          >
          <el-button
            type="primary"
            style="margin-top: 12px; margin-left: 30px"
            @click="ywOk"
            >审批通过</el-button
          >
        </div>

        <div style="margin-top: 30px">
          <!-- <el-timeline :reverse="reverse">
							    <el-timeline-item
							      v-for="(activity, index) in activities"
							      :key="index"
							      :timestamp="activity.timestamp">
							      {{activity.content}}
							    </el-timeline-item>
							</el-timeline> -->

          <el-timeline :reverse="reverse">
            <el-timeline-item
              v-for="(activity, index) in needStageData"
              :key="index"
              :timestamp="activity.endTime"
            >
              {{ activity.content }}
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-card>

      <!-- 展示需求 -->
      <el-card class="box-card" style="margin-top: 10px">
        <div style="display: flex; justify-content: space-between">
          <div style="font-weight: bold">需求信息</div>
        </div>
        <hr
          style="
            background-color: #eaeaea;
            color: #eaeaea;
            height: 1px;
            border: 1px none #000000;
          "
        />
        <div style="margin-bottom: 10px"></div>
        <div>
          <el-form ref="infoForm" :model="dispObj">
            <el-row>
              <el-col :span="24">
                <el-form-item label="需求编码" prop="needCode">
                  <!-- <span>   &nbsp;&nbsp;</span> -->
                  <el-input
                    type="text"
                    size="mini"
                    style="width: 990px"
                    disabled="true"
                    v-model="dispObj.needCode"
                    placeholder="请输入需求编码"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item label="需求名称" prop="needName">
                  <!-- <span>   &nbsp;&nbsp;</span> -->
                  <el-input
                    type="text"
                    size="mini"
                    style="width: 990px"
                    disabled="true"
                    v-model="dispObj.needName"
                    placeholder="请输入需求名称"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item
                  label="需求内容"
                  prop="needContent"
                  style="margin-left: 0px"
                >
                  <el-input
                    type="textarea"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    disabled="true"
                    :autosize="{ minRows: 8, maxRows: 8 }"
                    style="width: 990px"
                    v-model="dispObj.needContent"
                    placeholder="请输入需求内容"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col>
                <el-link
                  :href="dispObj.fileUrl"
                  v-if="dispObj.fileUrl"
                  target="_blank"
                  style="font-size: 13px"
                  size="mini"
                  download
                  type="primary"
                  :underline="false"
                  >查看附件</el-link
                >
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>

      <el-card class="box-card mycss">
        <el-button @click="doUpdateChanceS">关 闭</el-button>
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
import { kz90 } from "../../utils/MyFunction";

export default {
  name: "NeedList",
  data() {
    return {
      qx: true, // 总经理、销售总监 研发的权限
      qx1: true, // 总经理
      title: "",
      myId: null, // 临时存放需求id用
      xmShow: false,
      reverse: true, // 时间线  true 倒序(从上到下)；  false(从下到上)
      yfShowOpen: false, // 控制 意见/建议提交框和按钮的 显示
      ywShowOpen: false, // 控制 意见/建议提交框和按钮的 显示
      jdNormal: false, // 控制 正常 步骤条 的显示
      jdYanfa: false, //  控制 研发驳回 步骤条 的显示
      jdNopass: false, //  控制 审批不通过 步骤条 的显示
      needStages: [], // 需求阶段下拉框
      needData: [], // 存放查询结果
      needStageData: [], // 需求阶段变更数据
      createUserIds: [], // 需求发起人下拉框
      AdvanceDialogVisible: false, // 推进需求对话框是否显示
      loading: false,
      total: 0,
      page: 1,
      limit: 10,
      dialogVisible: false,
      searchValue: {
        // 查询条件
        needName: "", // 需求名称
        needCode: "", // 需求编号
        createUserId: "", // 需求发起人
        needStage: null, // 需求阶段
        rqScope: "", // 需求发起日期范围
      },
      activities: [
        {
          content: "活动按期开始",
          timestamp: "2018-04-15",
        },
        {
          content: "通过审核",
          timestamp: "2018-04-13",
        },
        {
          content: "创建成功",
          timestamp: "2018-04-11",
        },
      ],
      // 双击展示的对象
      dispObj: {
        needCode: "",
        needName: "",
        fileUrl: "",
        needContent: "",
        needStage: null,
      },
      // 新增需求对象
      inputObj: {
        id: null,
        needCode: "",
        needName: "",
        needContent: "",
        file: "",
        appendixUrl: "",
        createUserId: null,
        nextUserId: null,
        needStage: null,
        state: null,
        createTime: null,
        updateTime: null,
        submitFlag: null,
      },
      // 意见/建议 对象
      adviseObj: {
        id: null, // 需求主键id
        advise: "", // 意见/建议
        funcItem: null, // 功能项 ( 1-已保存单独提交需求按钮按下； 2-研发确认按钮按下  ；3-业务审核按钮按下；4-研发不同意；5-业务不同意；)
      },
      rules: {
        needName: [
          {
            required: true,
            message: "请输入需求名称",
            trigger: "blur",
          },
        ],
        needContent: [
          {
            required: true,
            message: "请输入需求内容",
            trigger: "blur",
          },
        ],
      },
      rules2: {
        advise: [
          {
            required: true,
            message: "请输入意见/建议",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.quanxian();
    this.initNeed();
    this.initDim();
  },
  methods: {
    moneyNumber(val) {
      return val.toLocaleString("zh-Hans-CN", {
        style: "currency",
        currency: "CNY",
      });
      // return val.toLocaleString()
    },
    quanxian() {
      if (!window.sessionStorage.getItem("userRoleId")) {
        //权限为空
        // 暂时不做处理，本来应该直接退出
      } else {
        if (window.sessionStorage.getItem("userRoleId") == 8) {
          this.qx = false;
        }
        if (window.sessionStorage.getItem("userRoleId") == 17) {
          this.qx = false;
          this.qx1 = false;
        }
        if (window.sessionStorage.getItem("userRoleId") == 30) {
          this.qx = false;
          this.qx1 = false;
        }
      }
    },
    kaiguan(sj) {
      var sf = kz90(sj);
      return sf;
    },
    kaiguan1(needStage) {
      var sf = true;
      if (needStage == 1) {
        // 只有 1、保存未提交  阶段才可以修改、与删除
        sf = false;
      }
      return sf;
    },
    onChange(file) {
      if (file) this.inputObj.file = file;
    },
    doChance() {
      this.dialogVisible = false;
      this.initNeed();
    },
    showEditView(data) {
      this.title = "编辑需求";
      this.dialogVisible = true;
      this.xmShow = true;
      this.inputObj = data;
    },
    deleteRecord(data) {
      // 删除按钮
      // alert(JSON.stringify(data))
      this.$confirm(
        "此操作将永久删除 [" + data.needName + "] 该条需求记录, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.postRequest2("/need/delete?id=" + data.id).then((resp) => {
            if (resp) {
              this.initNeed();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    doAddRecord() {
      // 保存按钮
      this.inputObj.submitFlag = 0; // 提交标志   0-保存未提交； 1-保存已提交
      if (this.inputObj.id) {
        // 编辑修改
        // alert(JSON.stringify(this.inputObj))
        this.$refs["inputForm"].validate((valid) => {
          if (valid) {
            //验证通过
            this.postRequest2("/need/update", this.inputObj).then((resp) => {
              if (resp) {
                this.dialogVisible = false;
                this.initNeed();
              }
            });
          }
        });
      } else {
        // 保存
        this.$refs["inputForm"].validate((valid) => {
          if (valid) {
            //验证通过
            const form = new FormData();
            Object.keys(this.inputObj).forEach((ele) => {
              if (this.inputObj[ele]) form.append(ele, this.inputObj[ele]);
            });
            if (this.inputObj.file) {
              form.set("file", this.inputObj.file.raw, this.inputObj.file.name);
            }
            form.set("submitFlag", 0);
            this.needPost("/need/add", form).then((resp) => {
              if (resp) {
                this.dialogVisible = false;
                this.initNeed();
                this.inputObj.file = "";
                this.$refs.upload.clearFiles();
              }
            });
          }
        });
      }
      // this.dialogVisible = false
    },
    doAddRecord2() {
      // 保存且提交按钮
      this.inputObj.submitFlag = 1; // 提交标志   0-保存未提交； 1-保存已提交
      if (this.inputObj.id) {
        // 编辑修改
        this.$refs["inputForm"].validate((valid) => {
          if (valid) {
            //验证通过
            this.postRequest2("/need/update", this.inputObj).then((resp) => {
              if (resp) {
                this.dialogVisible = false;
                this.initNeed();
              }
            });
          }
        });
      } else {
        // 保存
        this.$refs["inputForm"].validate((valid) => {
          if (valid) {
            //验证通过
            const form = new FormData();
            Object.keys(this.inputObj).forEach((ele) => {
              if (this.inputObj[ele]) form.append(ele, this.inputObj[ele]);
            });
            if (this.inputObj.file) {
              form.set("file", this.inputObj.file.raw, this.inputObj.file.name);
            }
            this.needPost("/need/add", form).then((resp) => {
              if (resp) {
                this.dialogVisible = false;
                this.initNeed();
                this.inputObj.file = "";
                this.$refs.upload.clearFiles();
              }
            });
          }
        });
      }
    },
    yfOk() {
      this.adviseObj.id = this.myId;
      this.adviseObj.funcItem = 2;
      this.$refs["adviseForm"].validate((valid) => {
        if (valid) {
          //验证通过
          this.postRequest2("/need/push", this.adviseObj).then((resp) => {
            if (resp) {
              this.initNeed();
              // this.getNeedStageData(this.adviseObj.id)
              this.AdvanceDialogVisible = false;
            }
          });
        }
      });
    },
    ywOk() {
      this.adviseObj.id = this.myId;
      this.adviseObj.funcItem = 3;
      this.$refs["adviseForm"].validate((valid) => {
        if (valid) {
          //验证通过
          this.postRequest2("/need/push", this.adviseObj).then((resp) => {
            if (resp) {
              this.initNeed();
              // this.getNeedStageData(this.adviseObj.id)
              this.AdvanceDialogVisible = false;
            }
          });
        }
      });
    },
    yfBack() {
      this.adviseObj.id = this.myId;
      this.adviseObj.funcItem = 4; // 功能项 ( 1-已保存单独提交需求按钮按下； 2-研发确认按钮按下  ；3-业务审核按钮按下；4-研发不同意；5-业务不同意；)
      this.$refs["adviseForm"].validate((valid) => {
        if (valid) {
          //验证通过
          this.postRequest2("/need/push", this.adviseObj).then((resp) => {
            if (resp) {
              this.initNeed();
              this.AdvanceDialogVisible = false;
            }
          });
        }
      });
    },
    ywBack() {
      this.adviseObj.id = this.myId;
      this.adviseObj.funcItem = 5; // 功能项 ( 1-已保存单独提交需求按钮按下； 2-研发确认按钮按下  ；3-业务审核按钮按下；4-研发不同意；5-业务不同意；)
      this.$refs["adviseForm"].validate((valid) => {
        if (valid) {
          //验证通过
          this.postRequest2("/need/push", this.adviseObj).then((resp) => {
            if (resp) {
              this.initNeed();
              this.AdvanceDialogVisible = false;
            }
          });
        }
      });
    },
    initDim() {
      // 商机阶段
      if (!window.sessionStorage.getItem("needStages")) {
        this.postRequest("/dim/dim_table_char/need_stage").then((resp) => {
          if (resp) {
            this.needStages = resp.result;
            this.saveDictCache("needStages", resp.result);
          }
        });
      } else {
        this.needStages = this.dictCache("needStages");
      }
      // 需求发起人 所有的销售人员
      if (!window.sessionStorage.getItem("createUserIds")) {
        this.getRequest("/user/queryAllSales").then((resp) => {
          if (resp) {
            this.createUserIds = resp;
            this.saveDictCache("createUserIds", resp);
          }
        });
      } else {
        this.createUserIds = this.dictCache("createUserIds");
      }
    },
    currentChange(currentPage) {
      this.page = currentPage;
      this.initNeed();
    },
    sizeChange(limit) {
      this.page = 1; // 改每页条数：回到第 1 页
      this.limit = limit;
      this.initNeed();
    },
    showAddView() {
      this.title = "添加需求";
      this.dialogVisible = true;
      this.xmShow = false;
      this.inputObj = {
        id: null,
        needCode: "",
        needName: "",
        needContent: "",
        appendixUrl: "",
        createUserId: null,
        nextUserId: null,
        needStage: null,
        state: null,
        createTime: null,
        updateTime: null,
        submitFlag: null,
      };
    },
    // 搜索入口：先回到第 1 页再查，避免在第 N 页搜索时结果不足一页而显示空白
    onSearch() {
      this.page = 1;
      this.initNeed();
    },

    initNeed() {
      var url = "/need/list?page=" + this.page + "&limit=" + this.limit;
      if (this.searchValue.needName) {
        url += "&needName=" + this.searchValue.needName;
      }
      if (this.searchValue.needCode) {
        url += "&needCode=" + this.searchValue.needCode;
      }
      if (this.searchValue.createUserId) {
        url += "&createUserId=" + this.searchValue.createUserId;
      }
      if (this.searchValue.needStage) {
        url += "&needStage=" + this.searchValue.needStage;
      }
      if (this.searchValue.rqScope) {
        url += "&rqScope=" + this.searchValue.rqScope;
      }
      this.loading = true;
      this.getRequest(url).then((resp) => {
        this.loading = false;
        if (resp) {
          console.log(resp.data);
          this.needData = resp.data;
          this.total = resp.count;
        }
      });
    },
    getNeedStageData(id) {
      var url = "/need/query_need_info?id=" + id;
      this.getRequest(url).then((resp) => {
        if (resp) {
          // alert(JSON.stringify(resp))
          this.needStageData = resp.result.needStagelList;
          // alert(JSON.stringify(this.needStageData))
        }
      });
    },
    advanceRecordView(data) {
      // 展现推进页面   双击 表格一行数据
      // alert(JSON.stringify(data))
      this.dispObj.fileUrl = data.fileUrl;
      this.dispObj.needCode = data.needCode;
      this.dispObj.needName = data.needName;
      this.dispObj.needStage = data.needStage;
      this.dispObj.needContent = data.needContent;

      this.adviseObj = {
        id: null,
        advise: "",
        funcItem: null,
      };

      if (data.needStage == 5) {
        this.jdNormal = false; // 正常的步骤条不显示
        this.jdYanfa = true; // 研发驳回的步骤条显示
        this.jdNopass = false; //  审批不通过的步骤条不显示
      } else if (data.needStage == 6) {
        this.jdNormal = false;
        this.jdYanfa = false;
        this.jdNopass = true;
      } else {
        //   data.needStage == 1,2,3,4
        this.jdNormal = true;
        this.jdYanfa = false;
        this.jdNopass = false;
      }

      // 双击后展示选中需求情况
      this.AdvanceDialogVisible = true;
      if (
        data.needStage == 2 &&
        window.sessionStorage.getItem("userRoleId") == 30
      ) {
        this.yfShowOpen = true;
      } else {
        this.yfShowOpen = false;
      }

      if (
        data.needStage == 3 &&
        (window.sessionStorage.getItem("userRoleId") == 8 ||
          window.sessionStorage.getItem("userRoleId") == 17)
      ) {
        this.ywShowOpen = true;
      } else {
        this.ywShowOpen = false;
      }

      //  this.needStageData   需求阶段变更数据
      this.getNeedStageData(data.id);

      this.myId = data.id;
    },
    doUpdateChanceS() {
      // alert("点击关闭按钮")
      this.AdvanceDialogVisible = false;
      this.initNeed();
    },
  },
};
</script>


<style>
/* 超出隐藏   不换行    点点显示*/
.diandian {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.mycss {
  text-align: center;
  position: fixed;
  left: 11%;
  right: 12%;
  bottom: 1px;
}
</style>
